import { AutogenModelEdibillingProfileDisplay, AutogenRowEdibillingProfileDisplay } from "./autogen/AutogenModelEdibillingProfileDisplay";

export class ModelEdibillingProfileDisplay extends AutogenModelEdibillingProfileDisplay<RowEdibillingProfileDisplay> {
	constructor() {
		super(RowEdibillingProfileDisplay);
	}
}

export class RowEdibillingProfileDisplay extends AutogenRowEdibillingProfileDisplay {
}